import React, { useState, useEffect } from "react";

import { openDialog } from "../../Containers/Dialog/actions";

import { AppBar } from "@material-ui/core";

import style from "./header.module.scss";

import images from "../../assets/flags";

import izyLogo from "../../assets/iziq_full.png";
import { Flag, FLAG_SIZE } from "../Flag/Flag";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { translate } from "../../translations/translate";

import { Link } from "react-router-dom";

import barcodeImage from "../../assets/barcode.png";
import { getKey } from "../../utils/localStorage";

export const Headers = (props) => {
  const { lang, withCode = false, withProfile = false } = props;

  const [isLogged, setLogin ] = useState(false);

  useEffect(() => {
    const token = getKey("token");
    if (token) setLogin(true);
  }, []);

  return (<AppBar position="sticky" elevation={4} className={style["wrapper"]}>
    <img className={style["logo"]} style={{ height: 40, width: 70 }} src={izyLogo} alt=""/>
    <div className={style["icons"]}>
      {withCode ?
      (<Link className={style["code"]} to="/qrcode">
        <img src={barcodeImage} />
      </Link> ) : null}
      <Flag
        isPrimary={true}
        isActive={false}
        onClick={props.actions.openDialog}
        image={images[lang]}
        size={FLAG_SIZE.Small}
      />
        {withProfile && isLogged ? (
        <Link className={style["user-button"]} to="/profile" >
          <i className="fas fas-2x fas fa-id-badge" aria-hidden="true" />
        </Link>
        ) : null}
    </div>
  </AppBar>);
};

const mapState = (state: any) => ({
  lang: state.languageSelector.language,
});

const mapDispatchToProps = (dispatch) =>  ({
  actions : bindActionCreators({
    openDialog: () => openDialog(translate("select-a-language")),
  }, dispatch),
});

export const Header = connect(mapState, mapDispatchToProps)(Headers);
